/**
 * The app's one active profile (Batch B3/B4).
 *
 * App.js owns `activeFamilyProfile` and provides it here, so a component deep
 * in the tree (Past Readings, the ChitraGupt preview, the session controller)
 * reads the same profile as the Home hero. `null` = the account owner.
 */
import { createContext, useContext } from 'react';

export const ActiveProfileContext = createContext(null);

export const useActiveProfile = () => useContext(ActiveProfileContext);
